import WidgetAccordion from "../widgets/WidgetAccordion";
//import WidgetAutocomplete from "../widgets/WidgetAutocomplete";

WidgetAccordion({
    'selectorParent': 'accordion',
    'selectorChild': 'accordion-panel',
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// EPL-349 Setting up a better autocomplete for the countries selection in the registration form
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Have turned this off due to problems with Chrome autofilling the field and also bringing up the choices.
// WidgetAutocomplete({
//     'selectorChoices': '#registration_countries',
//     'selectorField': '#registration_country',
// });

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Select all content type options if registration_email_preference_content_type_all is checked
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

document.getElementById('registration_email_preference_content_type_all').onclick = function() {
    let options = document.getElementById('registration_email_preference_content_type').getElementsByTagName('INPUT');
    for (let i = options.length - 1; i >= 0; i--) {
        options[i].checked = this.checked;
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Set a default email frequency
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const emailFrequencies = {'none' : 0, 'daily' : 1, 'weekly' : 2, 'monthly' : 3};

document.getElementById('registration_email_preference_email_update').onclick = function(){
    let wantEmailUpdates = this.checked;
    let select = document.getElementById('registration_email_preference_email_frequency');
    if (wantEmailUpdates) {
        select.options[emailFrequencies.weekly].selected = true
    } else {
        select.options[emailFrequencies.none].selected = true
    }
}